<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Bienvenid@</h2>
          <p></p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import store from '@/admin/store.js';

export default {
  name: 'AdminMainScreen',
  props: {},
  components: {},
  data() {
    return {
      sharedState: store.state,
    };
  },
  created() {},
  mounted() {},
  computed: {
    isSuper() {
      return this.sharedState.auth.super;
    },
  },
};
</script>

<style scoped></style>
